import { saveNavMode } from '@/shared/lib/navMode'

const mutations = {
  updateFilter (state, payload) {
    state.filter = payload
  },
  updateAlert (state, payload) {
    state.alert = payload
  },
  closeAlert (state) {
    state.alert = { active: false, message: null, type: null }
  },
  auth_request (state) {
    state.status = 'loading'
  },
  auth_success (state, token) {
    state.status = 'success'
    state.token = token
  },
  auth_error (state) {
    state.status = 'error'
  },
  logout (state) {
    state.status = ''
    state.token = ''
  },
  open_shift_success (state, work_shift) {
    state.work_shift = work_shift
  },
  update_active_links (state, active_links) {
    state.active_links = active_links
  },
  // Меню живёт отдельным компонентом, а переключает его кнопка в верхней
  // панели — состояние держим в сторе, чтобы они не тянулись пропами.
  update_nav_mode (state, value) {
    state.nav_mode = saveNavMode(value)
  },
  update_nav_drawer (state, value) {
    state.nav_drawer = !!value
  },
  update_error (state, value) {
    state.error = value
  },
  update_info (state, value) {
    state.info = value
  },
  close_shift (state) {
    state.work_shift = {}
  },
  updateReportConnect(state, value) {
    state.reports_connect = value
  },
  updateBillingReportConnect(state, value) {
    state.billing_reports_connect = value
  },
  updateWorkShiftConnect(state, value) {
    state.work_shift_connect = value
  },
  updateActionCableConnection(state, value) {
    state.action_cable_connect = value
  },
  updateActionCableMessage(state, value) {
    state.action_cable_message = value
  },
  set_user (state, user) {
    state.user = user
  },
  set_companies (state, companies) {
    state.companies = companies
  },
  set_company_id (state, id) {
    state.company_id = id
  },
  set_toast_id (state, id) {
    state.toast_id = id
  },
  set_container (state, container) {
    state.container = container
  },
  set_container_ticket (state, ticket) {
    state.container_ticket = ticket
  },
}

export default mutations
